import type { CSSProperties } from 'preact'

import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { captionStyle, uiTokens } from '#src/assets/ui/shared/styles.ts'
import type { CookieRecord } from '#src/services/cookieTranslationService/types.ts'

export function CookieTable({
  cookies,
  fallbackDomain,
  t,
}: {
  cookies: CookieRecord[]
  fallbackDomain: string
  t: CookieConsentTranslator
}) {
  const headers = [
    t('cookieName'),
    t('cookieExpires'),
    t('cookiePurpose'),
    t('cookieDomain'),
    t('cookieType'),
  ]

  return (
    <div style={containerStyle}>
      <table style={tableStyle}>
        <thead>
          <tr>
            {headers.map(headerText => (
              <th key={headerText} style={thStyle}>
                {headerText}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {cookies.map(cookie => {
            const cellValues = [
              cookie.cookie,
              cookie.retentionPeriod || t('cookieExpiresSession'),
              cookie.description || '-',
              cookie.domain || fallbackDomain || '-',
              t(`${cookie.category}CategoryTitle`),
            ]

            return (
              <tr key={cookie.cookie}>
                {cellValues.map((cellValue, index) => (
                  <td key={index} style={tdStyle}>
                    {cellValue}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

const tableStyle: CSSProperties = {
  width: '100%',
  fontSize: captionStyle.fontSize,
  borderCollapse: 'collapse',
  minWidth: 'max-content',
}

const thStyle: CSSProperties = {
  textAlign: 'left',
  padding: '0.5rem',
  borderBottom: `1px solid ${uiTokens.colors.gray200}`,
  fontWeight: '600',
  color: uiTokens.colors.gray900,
  whiteSpace: 'nowrap',
}

const tdStyle: CSSProperties = {
  padding: '0.5rem',
  borderBottom: `1px solid ${uiTokens.colors.gray100}`,
}

const containerStyle: CSSProperties = {
  boxSizing: 'border-box',
  display: 'block',
  marginTop: '0.75rem',
  maxWidth: '100%',
  minWidth: '0',
  overflowX: 'auto',
  width: '100%',
}
